import type { ReactNode } from "react";

interface SettingsCardProps {
    title: string;
    description?: string;
    children: ReactNode;
    tone?: "default" | "danger";
}

export function SettingsCard({ title, description, children, tone = "default" }: SettingsCardProps) {
    const isDanger = tone === "danger";
    return (
        <section
            className={`rounded-xl border bg-card p-6 shadow-sm ${
                isDanger ? "border-destructive/40" : "border-border"
            }`}
        >
            <header className="mb-5">
                <h2
                    className={`text-lg font-semibold ${
                        isDanger ? "text-destructive" : "text-foreground"
                    }`}
                >
                    {title}
                </h2>
                {description && (
                    <p className="mt-1 text-sm text-muted-foreground">
                        {description}
                    </p>
                )}
            </header>
            {children}
        </section>
    );
}
